import { Component, OnInit } from '@angular/core';
import {
  getOnlyOptionCategoriesProcessed,
  getTealiumLocation,
  isResOrPrepaidCustomer,
  OptionCategory,
  OptionType,
  Product,
} from '@dch/products-business-logic';
import {
  ApplicationState,
  getOptionsCategoriesConfig,
  getSelectedProductAvailableOptionsError,
  getSelectedProductAvailableOptionsLoaded,
  getSelectedProductDetails,
} from '../../../../store/reducers';
import { Store } from '@ngrx/store';
import { CustomerAccount } from '@proximus/common-business-logic';
import { OnDestroyHookDirective } from '../../../../shared/hooks';
import { CustomerService, LanguageService } from '@proximus/ng-common';
import { combineLatest } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import * as MagnoliaConfigActions from '../../../../store/actions/magnolia-config.actions';
import { ExcludeFavAppOptionsPipe } from '../../../../pipe/exclude-fav-app-options.pipe';
import { WebshopUtils } from '../../../../shared/webshop/webshop-utils';
import { ExcludeFlexEmergencyPipe } from '../../../../pipe/exclude-flex-emergency.pipe';
import { DetailsUtilService } from '../../../details-service.utils';

@Component({
  selector: 'mprd-available-options-container',
  templateUrl: './available-options-container.component.html',
})
export class AvailableOptionsContainerComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  OptionType = OptionType;

  selectedCategory: string;
  tealiumLocation: string;
  selectedProductFromStore: Product;
  selectedProduct: Product;
  hasError: boolean;
  isRes: boolean;
  isEBU: boolean;
  customerAccount: CustomerAccount;
  categories: Array<OptionCategory>;
  deepLinkCategory: string;
  availableOptionsLoaded: boolean;
  isURKidsCardSubscribed = false;
  isUr: boolean;

  constructor(
    private store: Store<ApplicationState>,
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private languageService: LanguageService,
    private excludeFavAppOptionsPipe: ExcludeFavAppOptionsPipe,
    private excludeFlexEmergencyPipe: ExcludeFlexEmergencyPipe,
    private readonly detailsUtilService: DetailsUtilService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.store.dispatch(new MagnoliaConfigActions.GetOptionsCategoriesConfig());
    this.addSubscription(
      this.store
        .select(getSelectedProductAvailableOptionsError)
        .subscribe((value) => {
          this.hasError = !!value;
        }),
    );
    this.addSubscription(
      combineLatest([
        this.route.queryParams,
        this.store.select(getOptionsCategoriesConfig),
        this.store.select(getSelectedProductDetails),
        this.store.select(getSelectedProductAvailableOptionsLoaded),
        this.customerService.getCustomerAccount(),
      ]).subscribe((res) => {
        const params = res[0];
        const config = res[1];
        const selectedProduct = res[2];
        this.availableOptionsLoaded = res[3];
        this.customerAccount = res[4];
        this.isRes = isResOrPrepaidCustomer(res[4]);
        this.isEBU = res[4].isEBU();
        if (this.isEBU === false) {
          this.isURKidsCardSubscribed = this.detailsUtilService.isKidsCardProduct(
            selectedProduct?.mobileProductDetails?.groupMpcUuid,
          );
        }
        if (params) {
          // do we still need deeplink to option category ??
          this.deepLinkCategory = params['cat'];
        }
        if (
          config &&
          selectedProduct &&
          JSON.stringify(this.selectedProductFromStore) !==
            JSON.stringify(selectedProduct.mobileProductDetails) &&
          this.availableOptionsLoaded
        ) {
          this.selectedProductFromStore = selectedProduct.mobileProductDetails;
          this.selectedProduct = selectedProduct.mobileProductDetails;
          this.tealiumLocation = getTealiumLocation(
            this.selectedProduct as any,
          );
          this.selectedProduct = {
            ...this.selectedProduct,
            options: this.excludeFlexEmergencyPipe.transform(
              this.excludeFavAppOptionsPipe.transform(
                this.selectedProduct.options,
              ),
            ),
          };
          const optionCategoriesProcessed = getOnlyOptionCategoriesProcessed(
            this.selectedProduct,
            config,
            this.languageService.getSelectedLanguage(),
            this.deepLinkCategory,
          );
          this.categories = optionCategoriesProcessed.categories;
          this.selectCategory(optionCategoriesProcessed.selectedCategoryId);
          if (this.isEBU === false) {
            WebshopUtils.publishCartRetrival(
              this.selectedProduct.installationId,
              this.selectedProduct.accessNumber,
              this.selectedProduct.plc,
            );
          }
        }
      }),
    );
  }

  selectCategory(cat: string) {
    this.selectedCategory = cat;
  }

}
